module.exports = __webpack_public_path__ + "img/Industrial_tipo.23cc55cd.svg";